<template>
  <WarrantsDataTableTab
    :headers="headers"
    error-title="Failed to load files"
    data-testid="warrants-files-accounts"
    searchable
    search-placeholder="Search account number"
    :filters="warrantsFilesAccountsTableFilters"
    :fetcher="fetchFiles"
    :items-from="itemsFrom"
  >
    <template #[`item.status`]="{ internalItem }">
      <SoChip
        :type="filesAccountStatusChipType(internalItem.raw.status)"
        :text="internalItem.raw.statusDisplay"
        size="small"
      />
    </template>
  </WarrantsDataTableTab>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoChip from "@/components/SoChip.vue"
  import WarrantsDataTableTab from "@/views/admin/warrants/components/WarrantsDataTableTab.vue"
  import { SoDataTableOptions } from "@/components/dataTable/SoDataTableServer.vue"
  import { SoDataTableHeader } from "@/types/components/SoDataTable"
  import {
    accountNumberColumn,
    createdAtColumn,
    deletedColumn,
    idColumn,
    statusColumn,
  } from "@/views/admin/warrants/warrantsColumns"
  import {
    WarrantsFilesAccountListResult,
    WarrantsFilesAccountService,
  } from "@/services/admin/WarrantsFilesAccountService"
  import {
    warrantsFilesAccountsTableFilters,
    WarrantsFilesAccountsTableFilters,
  } from "@/views/admin/warrants/warrantsFilesConfig"
  import { filesAccountStatusChipType } from "@/views/admin/warrants/warrantStatusChip"

  const headers: SoDataTableHeader[] = [
    idColumn,
    accountNumberColumn,
    { title: "Customer Name", key: "customerName", fallbackValue: "—" },
    {
      title: "File Type",
      key: "fileTypeDisplay",
      sortable: true,
      sortKey: "file_type",
    },
    {
      title: "DCA Type",
      key: "dcaTypeDisplay",
      sortable: true,
      sortKey: "dca_type",
    },
    statusColumn,
    { title: "Retry Count", key: "retryCount", sortable: true },
    {
      title: "Error Message",
      key: "errorMessage",
      sortable: false,
      fallbackValue: "—",
    },
    createdAtColumn,
    deletedColumn,
  ]

  export default defineComponent({
    components: {
      SoChip,
      WarrantsDataTableTab,
    },
    data() {
      return {
        headers,
        warrantsFilesAccountsTableFilters,
      }
    },
    methods: {
      filesAccountStatusChipType,
      fetchFiles({
        search,
        filters,
        page,
        pageSize,
        orderBy,
      }: SoDataTableOptions<WarrantsFilesAccountsTableFilters>) {
        return WarrantsFilesAccountService.getFiles(
          search,
          {
            status: filters.status.value,
            fileType: filters.fileType.value,
          },
          page,
          pageSize,
          orderBy,
        )
      },
      itemsFrom(result: WarrantsFilesAccountListResult) {
        return result.files
      },
    },
  })
</script>
